// extracted by mini-css-extract-plugin
export default {"title":"q--z","warning":"r--z","sizeOptionsLegendText":"s--z"};